import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, catchError, map, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ErrorHandlingService } from '../general/error-handling.service';
import { IAssignmentModuleCall } from 'src/app/interfaces/iassignment-module-call';
import { AppConstants } from 'src/app/app-constants';

@Injectable({
  providedIn: 'root',
})
export class AssignmentService {
  backendUrl: string = environment.backendUrl;

  constructor(
    private http: HttpClient,
    private errorHandlingService: ErrorHandlingService
  ) {}

  findByModuleAssignmentUuid(moduleAssignmentUuid: string): Observable<any> {
    if (!moduleAssignmentUuid)
      throw new Error('moduleAssignmentUuid is required');
    return this.http
      .get<any>(
        `${this.backendUrl}/call/findByModuleAssignmentUuid?moduleAssignmentUuid=${moduleAssignmentUuid}`
      )
      .pipe(
        map((result) => result),
        tap((res) => {
          const outcome = res ? 'fetched' : 'did not find';
          console.log(`findByModuleAssignmentUuid: ${outcome}`);
        }),
        catchError(
          this.errorHandlingService.handleError<any>(
            `findByModuleAssignmentUuid request`
          )
        )
      );
  }

  getCallDetails(
    callUuid: string,
    moduleAssignmentUuid: string | undefined
  ): Observable<any> {
    if (!callUuid) {
      throw new Error('callUuid is null');
    }
    if (!moduleAssignmentUuid) {
      throw new Error('moduleAssignmentUuid is null');
    }

    const params = new HttpParams()
      .set('callUuid', callUuid)
      .set('moduleAssignmentUuid', moduleAssignmentUuid);
    return this.http
      .get<any>(`${this.backendUrl}/call/findCallDetailsByCallUuid`, { params })
      .pipe(
        map((result) => result),
        tap((res) => {
          console.log(`response call details : ${res}`);
        }),
        catchError(
          this.errorHandlingService.handleError<any>('Get Call Details')
        )
      );
  }

  getPracticeCallResults(
    callUuid: string,
    moduleAssignmentUuid: string | undefined
  ): Observable<any> {
    if (!callUuid) {
      throw new Error('callUuid is null');
    }
    if (!moduleAssignmentUuid) {
      throw new Error('moduleAssignmentUuid is null');
    }

    const params = new HttpParams()
      .set('callUuid', callUuid)
      .set('moduleAssignmentUuid', moduleAssignmentUuid);
    return this.http
      .get<any>(
        `${this.backendUrl}/call/getPracticeCallResultsByCallAndModuleAssignment`,
        { params }
      )
      .pipe(
        map((result) => result),
        tap((res) => {
          console.log(`response call results : `, res);
        }),
        catchError(
          this.errorHandlingService.handleError<any>('Get Call Results')
        )
      );
  }
}
